import {
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonMenu,
  IonMenuToggle,
  IonNote,
} from '@ionic/react';

import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { homeSharp, homeOutline, listOutline, listSharp, videocamOutline, videocamSharp, gridOutline, gridSharp, mapOutline, mapSharp, helpOutline, helpSharp, cogOutline, cogSharp } from 'ionicons/icons';
import './Menu.css';
import { useSelector } from 'react-redux';
import { selectUserName } from '../features/user/userSlice';
import { PilgrimageState, selectPilgrimage } from '../features/pilgrimage/pilgrimageSlice';
import { InitialSetup } from '../pages/InitialSetup';
import { selectMode } from '../features/log/logSlice';

interface AppPage {
  url: string;
  iosIcon: string;
  mdIcon: string;
  title: string;
}

function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined;
}

const appPages: (pilgrimage : PilgrimageState) => AppPage[] = (pilgrimage) => [
  {
    title: 'Home',
    url: '/home',
    iosIcon: homeOutline,
    mdIcon: homeSharp
  },
  {
    title: 'Log',
    url: '/log',
    iosIcon: listOutline,
    mdIcon: listSharp
  },
  {
    title: 'Content',
    url: '/content',
    iosIcon: videocamOutline,
    mdIcon: videocamSharp
  },
  {
    title: 'Check-Ins',
    url: '/checkins',
    iosIcon: gridOutline,
    mdIcon: gridSharp
  },
  pilgrimage.name === 'Holy Land Pilgrimage'
  ? {
    title: 'Guidebook',
    url: '/guidebook',
    iosIcon: mapOutline,
    mdIcon: mapSharp
  }
  : null,
  {
    title: 'About',
    url: '/about',
    iosIcon: helpOutline,
    mdIcon: helpSharp
  }
].filter(notEmpty);

const Menu: React.FC = () => {
  const location = useLocation(),
    userName = useSelector(selectUserName),
    pilgrimage = useSelector(selectPilgrimage),
    mode = useSelector(selectMode),
    [showInitialSetup, setShowInitialSetup] = useState(false);

  return (
    <React.Fragment>
      <IonMenu contentId="main" type="overlay">
        <IonContent>
          <IonList>
            {pilgrimage.name && <IonListHeader>{pilgrimage.name}</IonListHeader>}
            {pilgrimage.church && <IonNote>{pilgrimage.church}</IonNote>}
            {userName && <IonNote>{userName} {pilgrimage.church !== pilgrimage.homeChurch && <React.Fragment><br/>({pilgrimage.homeChurch})</React.Fragment>}</IonNote>}
            {appPages(pilgrimage).map((appPage, index) => {
              return (
                <IonMenuToggle key={index} autoHide={false}>
                  <IonItem className={location.pathname === appPage.url ? 'selected' : ''} routerLink={appPage.url} routerDirection="none" lines="none" detail={false}>
                    <IonIcon slot="start" ios={appPage.iosIcon} md={appPage.mdIcon} />
                    <IonLabel>{appPage.title}</IonLabel>
                  </IonItem>
                </IonMenuToggle>
              );
            })}
            <IonItem onClick={(e) => { e.preventDefault(); setShowInitialSetup(true)}} lines="none" detail={false} routerDirection="none" href='#'>
              <IonIcon slot="start" ios={cogOutline} md={cogSharp}/>
              <IonLabel>Settings</IonLabel>
            </IonItem>
          </IonList>
        </IonContent>
      </IonMenu>
      {showInitialSetup && <InitialSetup
        onDismiss={() => setShowInitialSetup(false)}
        show={true}
        pilgrimage={pilgrimage}
        mode={mode}
        username={userName}
      />}
    </React.Fragment>
  );
};

export default Menu;
